@if (isValidatingProduct) {
  <div class="overlay full" id="productValidationLoader">
    <p class="text-center">{{appStrings.pleaseWait}}</p>
    <mat-spinner></mat-spinner>
  </div>
}

<!-- desktop template -->
<ng-container *appIsDesktop>
  <form [formGroup]="searchForm" id="searchField">
    <div class="searchProduct">
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>{{appStrings.accounts_search}}</mat-label>
        <input id="productsSearchField" #searchInput matInput [matAutocomplete]="productSelector" formControlName="searchField"
          placeholder="{{appStrings.products_searchPlaceholder}}" [minLength]="3" maxLength="200"
          pattern="^(\s|\S)*(\S)+(\s|\S)*$"
          (keyup.enter)="searchProduct()" (input)="searchAutocomplete()">
          <span id="iconSearch" matSuffix class="crm-industrial-font icon-search" (click)="searchProduct()"></span>
          @if (minCharactersError || searchForm.controls.searchField.hasError('pattern')) {
            <mat-error>{{appStrings.searchMinChars}}</mat-error>
          }
          <mat-autocomplete #productSelector="matAutocomplete" (optionSelected)="productSelected($event)"
            class="product-autocomplete">
            @if (!isLoading) {
              @for (foundElements of displayFoundProducts; track foundElements) {
                <mat-option [value]="foundElements" class="options">
                  <a>
                    <div class="product-option-title" [innerHTML]="foundElements.name | matchBold: searchForm.controls.searchField.value"></div>
                    <div class="product-option-subtitle" [innerHTML]="foundElements.productNumber | matchBold: searchForm.controls.searchField.value"></div>
                  </a>
                  <mat-divider></mat-divider>
                </mat-option>
              }
            }
            @if (isLoading) {
              <mat-option>
                <mat-spinner id="productsLoader"></mat-spinner>
              </mat-option>
            }
            @if (!hasResults && !minCharactersError && !isLoading) {
              <mat-option>{{appStrings.noResults}}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </form>
  </ng-container>


  <!-- mobile template -->
  <div *appIsMobile class="mobile">
    <mat-card>
      <mat-card-content>
        <form [formGroup]="searchForm" id="searchField">
          <mat-form-field appearance="outline" class="search-field-container no-subscript">
            <mat-label>{{appStrings.products_searchPlaceholderMobile}}</mat-label>
            <input id="productsSearchField" #searchInput matInput [matAutocomplete]="productSelector" formControlName="searchField"
              [minLength]="3" maxLength="200"
              pattern="^(\s|\S)*(\S)+(\s|\S)*$"
              (keyup.enter)="searchProduct()" (input)="searchAutocomplete()">
              @if (searchForm.controls.searchField.value) {
                <span id="iconDelete" matSuffix class="crm-industrial-font icon-remove" (click)="clearInput()"></span>
              }
              <span id="iconSearch" matSuffix class="crm-industrial-font icon-search" (click)="searchProduct()"></span>
              @if (minCharactersError || searchForm.controls.searchField.hasError('pattern')) {
                <mat-error class="error-container">{{appStrings.searchMinChars}}</mat-error>
              }
              <mat-autocomplete #productSelector="matAutocomplete" matAutocompletePosition="below" (optionSelected)="productSelected($event)"
                class="product-autocomplete">
                @if (!isLoading) {
                  <div class="results">
                    @for (foundElements of displayFoundProducts; track foundElements) {
                      <mat-option [value]="foundElements" class="options">
                        <a>
                          <div class="product-option-title" [innerHTML]="foundElements.name | matchBold: searchForm.controls.searchField.value"></div>
                          <div class="product-option-subtitle" [innerHTML]="foundElements.productNumber | matchBold: searchForm.controls.searchField.value"></div>
                        </a>
                        <mat-divider></mat-divider>
                      </mat-option>
                    }
                  </div>
                }
                @if (isLoading) {
                  <mat-option>
                    <mat-spinner id="productsLoader"></mat-spinner>
                  </mat-option>
                }
                @if (!hasResults && !minCharactersError && !isLoading) {
                  <mat-option>{{appStrings.noResults}}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </form>
        </mat-card-content>
      </mat-card>
    </div>
